import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadPriceFilteringRuleEpic } from './_epics/loadPriceFilteringRule.epic';
import { updatePriceFilteringRuleEpic } from './_epics/updatePriceFilteringRule.epic';
import { validatePriceFilteringRuleEpic } from './_epics/validatePriceFilteringRule.epic';
import { exportPriceFilteringRulesEpic } from './_epics/exportPriceFilteringRules.epic';
import { reloadPriceFilteringRuleListEpic } from './_epics/reloadPriceFilteringRule.epic';

export const priceFilteringRuleEpic = safeCombineEpics(
  loadPriceFilteringRuleEpic,
  updatePriceFilteringRuleEpic,
  validatePriceFilteringRuleEpic,
  exportPriceFilteringRulesEpic,
  reloadPriceFilteringRuleListEpic,
);
